import React from "react";
import Select from "react-select";
import { CSVLink } from "react-csv/lib";

import { Button } from "react-bootstrap";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faChevronLeft, faUpload, faDownload } from "@fortawesome/free-solid-svg-icons";

import DeployTile from "components/Tiles/DeployTile";
import ScoreTile from "components/Tiles/Score/ScoreTile";
import AibleStep from "components/CreateWizard/AibleStep";

import SalesforceImg from "images/datasource-sf.png";
import OracleImg from "images/datasource-ora.png";
import SAPImg from "images/datasource-sap.png";
import HTMLImg from "images/html-icon.png";
import RestImg from "images/restful-icon.png";
import JavaImg from "images/java-icon.png";
import PythonImg from "images/python-icon.png";
import RCodeImg from "images/rcode-icon.png";

import styles from "./style.module.css";

import FineUploaderTraditional from "fine-uploader-wrappers";
import FileInput from "react-fine-uploader/file-input";

export default class Deploy extends React.PureComponent {
  renderScore(score, index) {
    const { isDownloadLoading, handleDownload } = this.props;

    const fileLink =
      score && score.processed_url
        ? "https://s3.console.aws.amazon.com/s3/buckets/" + score.processed_url.slice(5) + "/"
        : undefined;

    return (
      <ScoreTile
        key={index}
        score={score}
        title={"Download Scored Dataset"}
        onClick={
          handleDownload
            ? () => handleDownload(score.id, score.model_name, fileLink)
            : fileLink
              ? () => window.open(fileLink)
              : undefined
        }
      />
    );
  }

  handleFile(event) {
    const { handleFileChange } = this.props;

    const file = event.currentTarget.files ? event.currentTarget.files[0] : undefined;

    document.getElementById("scoreUpload").value = "";

    return handleFileChange(file);
  }

  render() {
    const {
      id,
      model,
      label,
      match,
      handleBack,
      modelTile,
      csv,
      scores,
      error,
      updateDeploy,
      isScoreUploading,
      handleRestfulDeploy
    } = this.props;

    return (
      <div className={styles.deploy}>
        {model && model.label !== "decision-tree" && (
          <div className={styles.deployContainer}>
            <AibleStep
              message={"Please upload a CSV file that you would like to score."}
              style={{ margin: "0px", marginBottom: "10px" }}
            />
            <div className={styles.fHolder}>
              <div className={styles.topHolder}>
                <div className={styles.deployMessage}>{model.label}</div>
                {error && <div className={styles.error}>{"Error: " + error}</div>}
              </div>
              <div className={styles.flexHold}>
                <DeployTile
                  title={"Upload Scoring Dataset"}
                  middle={<FontAwesomeIcon icon={faUpload} />}
                  onClick={() => document.getElementById("scoreUpload").click()}
                  isActive={isScoreUploading !== true}
                  isLoading={isScoreUploading}
                />
                <div className={styles.deployTiles}>
                  {scores !== undefined && Object.keys(scores).map((sKey) => this.renderScore(scores[sKey], sKey))}
                </div>
              </div>
            </div>
          </div>
        )}
        <div style={{ display: "none" }}>
          <input type="file" ref="file" id="scoreUpload" onChange={(e) => this.handleFile(e)} />
        </div>
      </div>
    );
  }
}
